import React from 'react'

import Divider from '../../../../atoms/Divider'

import { getDayDividerDate } from '../../../../../utilities'
import useStyles from './styles'

const DayDivider = ({ date }) => {
  const classes = useStyles()

  return (
    <Divider>
      <div className={classes.root}>{getDayDividerDate(date)}</div>
    </Divider>
  )
}

export default DayDivider
